import React, { forwardRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import HeroImage from "../../images/LandingPageImage/Hero Section.webp";

const HeroSection = forwardRef(({ plans }, ref) => {
  const navigate = useNavigate();

  return (
    <div className="my-landing-p bg-white">
      <section
        id="home"
        ref={ref}
        className="min-h-[850px] py-12 flex justify-center items-center text-center lg:text-left"
      >
        <div className="flex flex-col lg:flex-row w-full px-4 sm:px-6 md:px-8 lg:px-12 m-0 justify-center items-center">
          {/* Text Content */}
          <div className="w-full lg:w-1/2 px-4 sm:px-6 lg:px-12 hero-content text-center lg:text-left">
            <h1
              className="
            montserrat-font-1 text-[22px] sm:text-[26px] md:text-[30px] lg:text-[36px]
            leading-snug font-semibold text-[#212529] font-sans mb-4
            hero-title
          "
            >
              Free Restaurant Billing & Management Software for Indian
              Restaurants
            </h1>

            <p
              className="
            montserrat-font-2 text-[14px] sm:text-[15px] md:text-[16px] text-[#212529] font-sans mb-6
            hero-description leading-relaxed
          "
            >
              From billing to delivery — Anlook helps restaurants reduce manual
              work, manage inventory, and grow sales effortlessly.
            </p>

            <ul
              className="
            montserrat-font-2 list-disc list-inside flex flex-col sm:flex-wrap gap-2 sm:gap-3
            text-[14px] sm:text-[15px] md:text-[16px] text-[#212529] font-sans
          "
            >
              <li>Automate messages to engage customers instantly</li>
              <li>Manage all chats from one smart dashboard</li>
              <li>Increase conversions with timely follow-ups</li>
              <li>Deliver personalized messages at scale</li>
              <li>Grow faster with efficient marketing automation</li>
            </ul>

            <div className="mt-6 flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Link
                to="/get-started"
                state={{ plan: plans }}
                className="montserrat-font-2 bg-green-700 hover:bg-green-800 text-white font-semibold py-3 px-6 rounded-md text-center landing-btn transition duration-300"
              >
                Start Free Trial
              </Link>

              {/* <button
                onClick={() => navigate("/pricing-page")}
                className="bg-white border border-green-700 hover:bg-green-50 text-green-700 font-semibold py-3 px-6 rounded-md landing-btn-2 transition duration-300"
              >
                See Pricing
              </button> */}
            </div>
          </div>

          {/* Hero Image */}
          <div className="w-full lg:w-1/2 mt-8 lg:mt-0 hero-image flex justify-center lg:justify-end px-4 sm:px-6 md:px-8 lg:pr-12">
            <img
              src={HeroImage}
              alt="Hero Section"
              className="w-full lg:w-[120%] h-auto object-contain home-responsive-img"
            />
          </div>
        </div>
      </section>
    </div>
  );
});

export default HeroSection;
